import { render, staticRenderFns } from "./PromoDetachmentsToAllocate.html?vue&type=template&id=1af80623&scoped=true&"
import script from "./PromoDetachmentsToAllocate.component.js?vue&type=script&lang=js&"
export * from "./PromoDetachmentsToAllocate.component.js?vue&type=script&lang=js&"
import style0 from "./PromoDetachmentsToAllocate.scss?vue&type=style&index=0&id=1af80623&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af80623",
  null
  
)

export default component.exports